import React from 'react';
import { Progress } from 'antd';

function Answer({ children }) {
	return <div className='SurveyResult'>{children}</div>;
}

const ResultAnswerCard = ({ answerVariants, totalAnswers, answers, question }) => {
	return Object.values(answerVariants).map((element, i) => {
		const variantTitle = answers[question.answers[i]].title;
		const percent = parseInt(element / totalAnswers * 100, 10);
		return (
			<Answer key={i}>
				<h5>{variantTitle}</h5>
				{question.type === 'single' ? null : <Progress showInfo={true} status='active' percent={percent}/>}
			</Answer>
		);
	});
};

export default ResultAnswerCard;


// WEBPACK FOOTER //
// ./src/components/ResultAnswerCard/ResultAnswerCard.js